import React from 'react';
import CustomerList from './CustomerList';

const ActiveCustomers = () => {
  return <CustomerList filterType="active" title="Aktif Müşteriler" />;
};

export default ActiveCustomers;
